<template>
  <div style="height: calc(100vh - 150px);">
    <el-table ref="ImportTable" :data="table" class="w-full" height="calc(100% - 50px)">
      <el-table-column type="index" label="序号" width="55" />
      <el-table-column label="状态" width="100" align="center">
        <template v-slot="{row:{doing,do_status}}">
          <el-icon v-if="doing" class="el-icon-loading" />
          <template v-else>
            <ml-tag v-if="do_status==='wait'" type="info">等待</ml-tag>
            <ml-tag v-else-if="do_status==='fail'" type="danger">失败</ml-tag>
            <ml-tag v-else type="success">成功</ml-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="do_error" label="结果" min-width="220" show-overflow-tooltip>
        <template v-slot="{row:{do_error,do_status}}">
          <span v-if="do_status==='success'" style="color: #24BA0C">导入成功</span>
          <span style="color: #FE1E1E">{{ do_error }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(field,label) in columns" :key="field" :prop="field" :label="label"
        show-overflow-tooltip
      />
    </el-table>
    <div class="hand-delivery-count">
      <div style="color: rgb(60, 60, 60);">
        <span class="mr-10">总计：<b>{{ table.length|numberFormat }}</b> 条</span>
        <span class="mr-10">已处理：<b>{{ count.done|numberFormat }}</b> 条</span>
        <span class="mr-10">导入成功：
          <b style="color: #24BA0C">{{ count.success|numberFormat }}</b> 条
        </span>
        <span class="mr-10">导入失败：<b style="color: #FE1E1E">{{ count.fail|numberFormat }}</b> 条</span>
      </div>
    </div>
    <div class="footer">
      <ml-button v-if="button_status==='wait'" text="确定" size="m" @click.native="handleSubmit" />
      <ml-button v-else-if="button_status==='doing'" text="终止" size="m" @click.native="handleBreak" />
      <ml-export-static
        v-else :data="table" text="下载结果" size="m" :module="`${module}_IMPORT_TEMPLATE`"
        class="ml-10"
        result
      />
    </div>
  </div>
</template>
<script>
import MlExportStatic from '@/components/MlExportStatic/index.vue'
import MlTag from '@/components/MlTag/index.vue'
import MlButton from '@/components/MlButton/index.vue'
import { module_config } from '@/components/MlExportStatic'
import { lodashFilByObjValues } from '@/utils'

export default {
  name: 'MlImportStep2',
  components: { MlExportStatic, MlTag, MlButton },
  props: {
    module: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      button_status: 'wait',
      stop: false,
      table: [],
      count: {
        done: 0,
        fail: 0,
        success: 0
      }
    }
  },
  computed: {
    columns() {
      return module_config[`${this.module}_IMPORT_TEMPLATE`].fields
    }
  },
  methods: {
    handleBreak: function() {
      this.stop = true
      this.button_status = 'stop'
    },
    handleSubmit: async function() {
      this.stop = false
      this.button_status = 'doing'
      this.count = {
        done: 0,
        fail: 0,
        success: 0
      }
      const Dom = this.$refs.ImportTable
      for (let i = 0; i < this.table.length; i++) {
        if (this.stop) {
          this.stop = false
          break
        }
        // { doing: false, do_error: null, do_status: 'wait' }
        const row = this.table[i]

        this.tableScrollToRow(Dom, i)
        this.table[i].doing = true
        // 请求后端接口，执行导入操作
        const params = lodashFilByObjValues(row, this.columns)
        params.is_import = true
        let result = {}
        result = await this.$api.importSignInfo(params)
        const { code, msg } = result

        this.table[i].doing = false
        if (i === this.table.length - 1) {
          this.button_status = 'done'
        }
        this.count.done++

        // 因为成功失败返回数据结构不一样，差一层对象，所以这里要判断一下！!!
        if (typeof code !== 'undefined') {
          if (code !== 200) {
            this.table[i].do_error = msg || '服务异常'
            this.table[i].do_status = 'fail'
            this.table[i].do_status_alia = '失败'
            this.table[i].do_remark_alia = msg || '服务异常'
            this.count.fail++
            continue
          }
        }

        this.count.success++
        this.table[i].do_status = 'success'
        this.table[i].do_status_alia = '成功'
        this.table[i].do_remark_alia = '导入成功'
      }
    },
    tableScrollToRow: function(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row')
      let scrollTop = 0
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break
        }
        scrollTop += theTableRows[i].offsetHeight
      }
      tableElement.bodyWrapper.scrollTop = scrollTop - 150
    },
    setData: function(data) {
      this.table = data || []
      this.count = {
        done: 0,
        fail: 0,
        success: 0
      }
      this.button_status = 'wait'
    }
  }
}
</script>
<style scoped lang="scss">
</style>
